import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { generateTitle } from '@/utils/i18n'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
 // start progress bar
 NProgress.start()

 // set page title
 // i18n这里会报错
 // document.title = getPageTitle(to.meta.title)
 document.title = getPageTitle()

 // determine whether the user has logged in
 const hasToken = getToken()

 if (hasToken) {
  if (to.path === '/login') {
   // if is logged in, redirect to the home page
   next({ path: '/' })
   NProgress.done()
  } else {
   // const hasGetUserInfo = store.getters.name
   // if (hasGetUserInfo) {

   // determine whether the user has obtained his permission roles through getInfo
   const hasRoles = store.getters.roles && store.getters.roles.length > 0
   const hasPermissionRoutes = store.getters.permission_routes && store.getters.permission_routes.length > 0
   if (hasRoles && hasPermissionRoutes) {
    next()
   } else {
    try {
     // get user info
     // console.log('store - getinfo')
     // await store.dispatch('user/getInfo')

     // next()
     // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
     if (!hasRoles) {
      await store.dispatch('user/getInfo')
     }
     // getInfo waits for /user/rbac/me and stores the effective RBAC roles.
     // Its return value is the legacy user DTO, whose roles may differ.
     const roles = store.getters.roles

     // generate accessible routes map based on roles
     const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

     // todo 1008 获取板载数据,要带userId
     store.dispatch('boarddata/prepareData').then(res => {})

     // dynamically add accessible routes
     router.addRoutes(accessRoutes)

     // hack method to ensure that addRoutes is complete
     // set the replace: true, so the navigation will not leave a history record
     next({ ...to, replace: true })
    } catch (error) {
     // remove token and go to login page to re-login
     await store.dispatch('user/resetToken')

     // TEST 1031 Message.error
     Message.error(error + '' || 'Has Error')
     // Message.error({ message: response.data.data || '出现错误，请稍后再试' })

     next(`/login?redirect=${to.path}`)
     NProgress.done()
    }
   }
  }
 } else {
  /* has no token*/

  if (whiteList.indexOf(to.path) !== -1) {
   // in the free login whitelist, go directly
   next()
  } else {
   // other pages that do not have permission to access are redirected to the login page.
   next(`/login?redirect=${to.path}`)
   NProgress.done()
  }
 }
})

router.afterEach(() => {
 // finish progress bar
 NProgress.done()
})
